/**
 * Border Glow Component - Disabled
 * Removed glow and double-border hover effect from cards per user request.
 */
export function mountBorderGlow(root = document) {
	if (typeof document !== "undefined") {
		document.querySelectorAll(".solufy-border-glow").forEach((el) => el.remove());
		document.querySelectorAll(".solufy-border-glow-card").forEach((el) => {
			el.classList.remove("solufy-border-glow-card");
			el.querySelectorAll?.(".solufy-border-glow-content, .solufy-glow-relative").forEach((child) => {
				child.classList.remove("solufy-border-glow-content", "solufy-glow-relative");
			});
		});
	}
	return () => {};
}
